import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateContactForm(section, textLines, form) {

  // Individual tweens
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  let formTween = form ? gsap.to(form, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    ease: "power1.out",
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl
    .add(textLinesTween)
    .add(formTween, "-=0.4");
}